const STORAGE_KEY = "uk_ab_variants";

export interface Experiment {
  id: string;
  variants: string[];
  weights?: number[]; // default: equal distribution
}

function loadVariants(): Record<string, string> {
  if (typeof window === "undefined") return {};
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

function saveVariants(variants: Record<string, string>): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(variants));
  } catch {
    // localStorage unavailable
  }
}

export function getVariant(experiment: Experiment): string {
  const all = loadVariants();

  // Return existing assignment
  if (all[experiment.id]) return all[experiment.id];

  // Assign new variant
  const { variants, weights } = experiment;
  let assigned: string;

  if (weights && weights.length === variants.length) {
    const totalWeight = weights.reduce((a, b) => a + b, 0);
    const rand = Math.random() * totalWeight;
    let cumulative = 0;
    assigned = variants[variants.length - 1];
    for (let i = 0; i < weights.length; i++) {
      cumulative += weights[i];
      if (rand < cumulative) {
        assigned = variants[i];
        break;
      }
    }
  } else {
    assigned = variants[Math.floor(Math.random() * variants.length)];
  }

  all[experiment.id] = assigned;
  saveVariants(all);
  return assigned;
}

export function getAllVariants(): Record<string, string> {
  return loadVariants();
}
